<!-- 图书柜-公共内容模板 -->
<template>
  <div class="BookcaseMArea">
    <div :class="['BookcaseNavBar', {flexEnd: $route.meta.hideBack}]">
      <span class="back" @click="back" v-show="!$route.meta.hideBack"></span>
      <span class="title">{{$route.meta.title}}</span>
      <span class="logout" v-show="!$route.meta.hideLogout" @click="logout">退出登录</span>
    </div>
    <router-view />
  </div>
</template>

<script>
  let vm

  export default {
    name:'BookcaseMArea',
    components: {
    },
    computed: {
    },
    data() {
      return {
      }
    },
    created() {
      vm = this
    },
    mounted () {
      // console.log('this', this.$route)
    },
    methods: {
      // 返回
      back () {
        vm.$router.go(-1)
      },
      // 退出登录
      logout () {
        vm.$store.state.type = ''
        vm.$store.state.eUserInfo = ''
        vm.$store.state.ECMall_activeGoods = {}
        vm.$router.push('/Bookcase/Index')
      },
    },
    watch: {
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcaseMArea {
    width: 100%;
    height: 100%;
    background-color: #f6f6f6;
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Common/MainArea.vue